import { render, staticRenderFns } from "./R14.vue?vue&type=template&id=54787f98&scoped=true"
import script from "./R14.vue?vue&type=script&lang=js"
export * from "./R14.vue?vue&type=script&lang=js"
import style0 from "./R14.vue?vue&type=style&index=0&id=54787f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54787f98",
  null
  
)

export default component.exports